<template>
	<modal
		class="video-modal"
		:size="'medium'">
		<template slot="header">
			<h3><i class="material-icons">play_circle_filled</i>Embed YouTube Video</h3>
		</template>
		<template slot="body">
			<div class="form-group">
				<label>Paste your YouTube Video URL</label>
				<input
					type="text"
					class="form-control"
					v-model="url">
			</div>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-default"
				@click="close">
				Cancel
			</button>
			<button
				type="button"
				class="btn btn-primary"
				:disabled="!isUrlValid"
				@click="insert">
				Insert Video
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { youtubeParser } from '../lib/helper';

export default {
	name: 'VideoModal',
	components: {
		Modal,
	},
	data() {
		return {
			url: '',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		insert() {
			const data = {
				src: this.youtubeId,
			};
			this.$emit('insert', data);
		},
	},
	computed: {
		youtubeId() {
			return youtubeParser(this.url);
		},
		isUrlValid() {
			return this.url !== '';
		},
	},
	created() {
	},
	watch: {
	},
};
</script>
